(() => {
 'use strict';
 const mount = scope => {
  scope.querySelectorAll('[data-design-gallery]').forEach(root => {
   if(root.dataset.galleryReady)return;
   root.dataset.galleryReady='true';
   const panels=[...root.querySelectorAll('[data-design-panel]')],thumbs=[...root.querySelectorAll('[data-design-thumb]')],stage=root.querySelector('[data-design-stage]'),position=root.querySelector('[data-design-position]'),dialog=root.querySelector('[data-design-zoom-dialog]'),content=root.querySelector('[data-design-zoom-content]');
   if(!panels.length)return;
   let index=0,origin,start,swiped=false;
   const show=n=>{
    index=(n+panels.length)%panels.length;
    panels.forEach((panel,i)=>panel.hidden=i!==index);
    const image=panels[index].querySelector('img');if(image)image.loading='eager';
    thumbs.forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.designThumb===panels[index].dataset.designPanel)));
    position.textContent=(index+1)+' / '+panels.length;
    root.querySelectorAll('[data-design-prev],[data-design-next]').forEach(b=>b.disabled=panels.length<2);
   };
   root.querySelector('[data-design-prev]').addEventListener('click',()=>show(index-1));
   root.querySelector('[data-design-next]').addEventListener('click',()=>show(index+1));
   thumbs.forEach(b=>b.addEventListener('click',()=>show(panels.findIndex(p=>p.dataset.designPanel===b.dataset.designThumb))));
   stage.addEventListener('keydown',e=>{if(!['ArrowLeft','ArrowRight'].includes(e.key))return;e.preventDefault();const rtl=root.dir==='rtl';show(index+(e.key==='ArrowRight'?(rtl?-1:1):(rtl?1:-1)));});
   stage.addEventListener('pointerdown',e=>{if(e.pointerType==='touch')start={x:e.clientX,y:e.clientY};swiped=false;},{passive:true});
   stage.addEventListener('pointerup',e=>{if(!start)return;const dx=e.clientX-start.x,dy=e.clientY-start.y;start=null;if(Math.abs(dx)>55&&Math.abs(dx)>Math.abs(dy)*1.5){show(index+(dx<0?(root.dir==='rtl'?-1:1):(root.dir==='rtl'?1:-1)));}},{passive:true});
   stage.addEventListener('click',event=>{if(swiped){event.preventDefault();event.stopImmediatePropagation();swiped=false;}},true);
   root.querySelectorAll('[data-design-zoom]').forEach(button=>button.addEventListener('click',()=>{origin=button;const image=panels[index].querySelector('img')?.cloneNode(true);if(!image)return;image.removeAttribute('sizes');image.removeAttribute('srcset');image.loading='eager';content.replaceChildren(image);dialog.showModal();}));
   root.querySelector('[data-design-zoom-close]').addEventListener('click',()=>dialog.close());
   dialog.addEventListener('close',()=>{content.replaceChildren();origin?.focus({preventScroll:true});});
   show(0);
  });
 };
 window.EGWDesignGallery={mount};
 const boot=()=>mount(document);
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot);else boot();
 document.addEventListener('shopify:section:load',boot);
 document.addEventListener('egw:design-gallery-mount',event=>mount(event.target));
})();
